﻿<div class="route-component">
    <div class="report-component">

        <h4>
            Report Viewer
        </h4>

        <div class="line-connector"></div>

         <div class="action-bar">
            <div class="action-bar right">
                <div class="action-container">
                    <button (click)="backtoReportSelection()">Back to Report Selection <i class="fas fa-arrow-left"></i></button>
                    
                    <button *ngIf="!isAnnexureExport && !isAgeingExport" (click)="exportReport('excel')">Download Excel <i class="fas fa-download"></i></button>
                    <button *ngIf="isAnnexureExport || isAgeingExport" (click)="onExcelAction()">Email Excel <i class="fas fa-envelope"></i></button>

                    <button *ngIf="!isAnnexureExport && !isAgeingExport" (click)="exportReport('pdf')">Download PDF <i class="fas fa-download"></i></button>
                    <!-- PDF email export not yet implemented for bulk exports -->
                </div>
            </div>
        </div>

        <div class="report-window loader-host">
            <div *ngIf="loading" class="loading-overlay">
                <div class="loading-indicator">
                    <i class="fas fa-spinner fa-spin"></i>
                    <span>Loading report…</span>
                </div>
            </div>

            <div class="report-container" [class.dimmed]="loading" [class.rpt-turnover-checklist]="isChecklist" [innerHTML]="safeHtml"></div>
        </div>
    </div>
</div>
